import Vue from 'vue'
import Popup from './popup'
import store from '@/store'
import router from '@/router'

function popup (props) {
	const _props = props || {}

    const Instance = new Vue({
        render (h) {
            return h(Popup, {
                props: _props
            })
        },
        store,
        router
    })

    const component = Instance.$mount()
    document.body.appendChild(component.$el)

    return Instance.$children[0]
}

export default {
	name: 'Popup',
	open (component, params = {}, query = {}) {
		popup({
			component: component,
            routeParams: params,
            routeQuery: query
		})
	},
	close () {

	}
}


// WEBPACK FOOTER //
// ./src/components/popup/index.js